import React, { useState, useEffect } from 'react';
import axios from 'axios';

//const API = process.env.REACT_APP_API_URL || 'https://sohaibenterprises.cloud/api';
const API = 'http://localhost:5000/api';
const RawMaterialsTab = () => {
  const [rawMaterials, setRawMaterials] = useState([]);
  const [suppliers, setSuppliers]       = useState([]);
  const [loading, setLoading]           = useState(true);
  const [showForm, setShowForm]         = useState(false);
  const [formData, setFormData]         = useState({
    supplier_id: '', roll_number: '', total_meters: '',
    purchase_price: '', purchase_date: '', notes: ''
  });
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState('');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchAll = async () => {
    try {
      const [rawRes, supRes] = await Promise.all([
        axios.get(`${API}/tape/raw-materials`, { headers }),
        axios.get(`${API}/tape/suppliers`, { headers }),
      ]);
      setRawMaterials(rawRes.data.data || []);
      setSuppliers(supRes.data.data || []);
    } catch {
      setError('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAll(); }, []);

  const handleSave = async () => {
    if (!formData.roll_number || !formData.total_meters || !formData.purchase_date) {
      setError('Roll number, total meters and purchase date are required');
      return;
    }
    setSaving(true);
    try {
      await axios.post(`${API}/tape/raw-materials`, formData, { headers });
      setShowForm(false);
      setFormData({ supplier_id: '', roll_number: '', total_meters: '', purchase_price: '', purchase_date: '', notes: '' });
      fetchAll();
    } catch {
      setError('Failed to save raw material');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this raw material?')) return;
    try {
      await axios.delete(`${API}/tape/raw-materials/${id}`, { headers });
      fetchAll();
    } catch {
      setError('Failed to delete');
    }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '60px', color: '#7f8c8d' }}>Loading...</div>;

  return (
    <div>
      {/* ── HEADER ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#2c3e50', margin: 0 }}>🎞️ Raw Materials</h2>
        <button
          onClick={() => { setShowForm(true); setError(''); }}
          style={{ padding: '12px 24px', background: '#f39c12', border: 'none', borderRadius: '10px', color: 'white', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}
        >
          + Add Raw Material
        </button>
      </div>

      {error && (
        <div style={{ background: '#fdecea', border: '1px solid #e74c3c', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px', color: '#e74c3c' }}>
          {error}
        </div>
      )}

      {/* ── FORM ── */}
      {showForm && (
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)', marginBottom: '24px', border: '2px solid #f39c12' }}>
          <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#2c3e50', marginBottom: '20px' }}>Add New Raw Material</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Supplier</label>
              <select
                value={formData.supplier_id}
                onChange={e => setFormData({ ...formData, supplier_id: e.target.value })}
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              >
                <option value="">Select Supplier</option>
                {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Roll Number *</label>
              <input
                type="text"
                value={formData.roll_number}
                onChange={e => setFormData({ ...formData, roll_number: e.target.value })}
                placeholder="e.g. ROLL-001"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Total Meters *</label>
              <input
                type="number"
                value={formData.total_meters}
                onChange={e => setFormData({ ...formData, total_meters: e.target.value })}
                placeholder="e.g. 4000"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Purchase Price (Rs)</label>
              <input
                type="number"
                value={formData.purchase_price}
                onChange={e => setFormData({ ...formData, purchase_price: e.target.value })}
                placeholder="e.g. 15000"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Purchase Date *</label>
              <input
                type="date"
                value={formData.purchase_date}
                onChange={e => setFormData({ ...formData, purchase_date: e.target.value })}
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Notes</label>
              <input
                type="text"
                value={formData.notes}
                onChange={e => setFormData({ ...formData, notes: e.target.value })}
                placeholder="Optional notes"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
            <button onClick={handleSave} disabled={saving} style={{ padding: '10px 24px', background: '#f39c12', border: 'none', borderRadius: '8px', color: 'white', cursor: 'pointer', fontWeight: '600' }}>
              {saving ? 'Saving...' : 'Save'}
            </button>
            <button onClick={() => setShowForm(false)} style={{ padding: '10px 24px', background: '#f0f0f0', border: 'none', borderRadius: '8px', color: '#555', cursor: 'pointer', fontWeight: '600' }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* ── TABLE ── */}
      <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                {['#', 'Roll No', 'Supplier', 'Total Meters', 'Remaining', 'Purchase Price', 'Date', 'Actions'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', color: '#7f8c8d', fontWeight: '600' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rawMaterials.map((item, index) => {
                const usedPercent = ((item.total_meters - item.remaining_meters) / item.total_meters * 100).toFixed(0);
                return (
                  <tr key={item.id} style={{ borderBottom: '1px solid #f0f0f0', background: index % 2 === 0 ? 'white' : '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#7f8c8d' }}>{index + 1}</td>
                    <td style={{ padding: '12px 16px', fontWeight: '700', color: '#2c3e50' }}>{item.roll_number}</td>
                    <td style={{ padding: '12px 16px', color: '#555' }}>{item.supplier_name || '-'}</td>
                    <td style={{ padding: '12px 16px', color: '#555' }}>{item.total_meters}m</td>
                    <td style={{ padding: '12px 16px' }}>
                      <span style={{ fontWeight: '700', color: item.remaining_meters < 500 ? '#e74c3c' : '#27ae60' }}>
                        {item.remaining_meters}m
                      </span>
                      <span style={{ fontSize: '12px', color: '#7f8c8d', marginLeft: '6px' }}>({usedPercent}% used)</span>
                    </td>
                    <td style={{ padding: '12px 16px', color: '#555' }}>Rs {Number(item.purchase_price || 0).toLocaleString()}</td>
                    <td style={{ padding: '12px 16px', color: '#7f8c8d' }}>{new Date(item.purchase_date).toLocaleDateString()}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <button
                        onClick={() => handleDelete(item.id)}
                        style={{ padding: '6px 14px', background: '#e74c3c', border: 'none', borderRadius: '6px', color: 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
              {rawMaterials.length === 0 && (
                <tr>
                  <td colSpan="8" style={{ padding: '40px', textAlign: 'center', color: '#7f8c8d' }}>No raw materials added yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RawMaterialsTab;